var map = {
	"./cat.svg": "db7d",
	"./chat.svg": "7849",
	"./completed-task.svg": "d9fc",
	"./logo.png": "eed9",
	"./markdown.svg": "b1cc",
	"./pencil.svg": "1b92",
	"./upload.svg": "63fb",
	"./video-call.svg": "80b3",
	"./video-player.svg": "30a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff1e";